import * as types from './type';

const initialState = {
    homeCuratedList: [],
    curatedAlbums: [],
    curatedSongs: '',
    curatedGenres: '',
    suggestedList: ''
};



export default function curatedReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.GET_HOME_CURATED_LIST: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          homeCuratedList: action.payload.data.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    
    case types.GET_CURATED_ALBUMS: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          curatedAlbums: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }

    
    case types.GET_CURATED_SONGS: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          curatedSongs: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }

    
    case types.GET_GENRE_CURATED_ALBUMS: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          curatedGenres: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }

    
    case types.GET_SUGGESTED_CURATED_ALBUMS: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          suggestedList: action.payload.data.data
        }
      } else {
        return {
          ...state
        }
      }
    }

    default: {
      return {
        ...state
      };
    }
    
  }

}